import "./PageNotFound.css";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button"; // Import Button from PrimeReact or the appropriate library
import styles from "../Admin/Projects/AddProject.module.css";
import React from "react";

export default function PageNotFound() {
  const navigate = useNavigate();
  // Use sessionStorage to initialize the ref value (only once)
  const hasClickedRef = React.useRef(
    sessionStorage.getItem("hasClicked") === "true"
  );

  React.useEffect(() => {
    if (!hasClickedRef.current) {
      navigate("/");
      hasClickedRef.current = true;
      sessionStorage.setItem("hasClicked", "true"); // persist across visits
    }
  }, [hasClickedRef.current]);

  const handleBack = () => {
    navigate(-1);
    //  /page-not-found
    setTimeout(() => {
      if (
        window.location.pathname === "/page-not-found" ||
        window.location.pathname === "/no-access"
      ) {
        navigate("/");
      }
    }, 500); // adjust time as needed
  };
  return (
    <div className="flex justify-content-center align-items-center h-screen">
      <div className="md:pt-5 mt-5 md:col-6">
        <div className="empty-state">
          <div className="bg-white border-green-50 flex border-round-xl col-12 w-100">
            <div className="section-for-title lg:px-3 justify-content-start">
              <span>
                <Button
                  icon="pi pi-arrow-left"
                  label="Back"
                  className={`${styles?.btnProject}`}
                  onClick={() => handleBack()}
                />
              </span>
            </div>
          </div>
          <i className="pi pi-info-circle empty-state-icon"></i>
          <h2 className="empty-state-title">Page Not Found</h2>
          <p className="empty-state-message">
            Your currently trying to access invalid page.
          </p>
        </div>
      </div>
    </div>
  );
}
